'use strict';
var parent = require('../../actual/symbol/iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/symbol/iterator.js
// module id = 641
// module chunks = 13